import { authHeader } from '../_helpers';
import axios from "axios";

export async function getApiRequest(path, params) {
  let requestOptions = {
    method: 'GET',
    headers: authHeader(),
    params: params,
  };
  let response = await axios('/api' + path, requestOptions)
    .catch(async function(error){
      console.error(error.response)
      if (error.response.statusText == "Unauthorized"){
        console.debug('Log out')
        self.$store.dispatch('authentication/logout');
      }
      return
    })
  return response.data
}

export async function postApiRequest(path, data, params) {
  let requestOptions = {
    method: 'POST',
    headers: authHeader(),
    params: params,
    data: data,
  };
  let response = await axios('/api' + path, requestOptions)
    .catch(async function(error){
      console.error(error.response)
      return
    })
  return response.data
}

export async function postFileApiRequest(path, data, params) {
  let headers = authHeader()
  headers['Content-Type'] = 'multipart/form-data'

  let requestOptions = {
    method: 'POST',
    headers: headers,
    params: params,
    data: data,
  };

  let response = await axios('/api' + path, requestOptions)
    .catch(async function(error){
      console.error(JSON.stringify(error))
      return
    })
  return response.data
}

export async function putApiRequest(path, data, params) {
  let requestOptions = {
    method: 'PUT',
    headers: authHeader(),
    params: params,
    data: data,
  };
  let response = await axios('/api' + path, requestOptions)
    .catch(async function(error){
      console.error(error.response)
      return
    })
  return response.data
}

export async function deleteApiRequest(path, params) {
  let requestOptions = {
    method: 'DELETE',
    headers: authHeader(),
    params: params,
  };
  let response = await axios('/api' + path, requestOptions)
    .catch(async function(error){
      console.error(error.response)
      return
    })
  return response.data
}
